import { createContext, useContext } from 'react';

export const DOC_ELEMENTS_DEFAULT_VALUE = {
  headEl: typeof document !== 'undefined' ? document.head : null,
  bodyEl: typeof document !== 'undefined' ? document.body : null,
} as DocElementsContextType;

export type DocElementsContextType = { headEl: HTMLElement; bodyEl: HTMLElement | ShadowRoot };

const DocElementsContext = createContext<DocElementsContextType>(DOC_ELEMENTS_DEFAULT_VALUE);

const useDocElementsContext = () => {
  return useContext(DocElementsContext);
};

export { useDocElementsContext, DocElementsContext };
